import { Button, cn } from '@riac/design-system';
import React, { useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { LoginContext } from 'src/lib/LoginContext';


export type LoginToUseProps = React.PropsWithChildren<{
  overlayText: string,
  hideChildren?: boolean,
  alwaysShowOverlay?: boolean,
  childrenWrapperClassName?: string,
  className?: string,
}>;

export const LoginToUse = (props: LoginToUseProps): JSX.Element => {
  const [mobilePressedState, setMobilePressedState] = useState<boolean>(props.alwaysShowOverlay);
  const { isLoggedIn } = useContext(LoginContext);
  const location = useLocation();
  const history = useHistory();

  const overlayClassName = 'light absolute -top-1 -left-1 -right-1 -bottom-1 z-10 flex flex-row items-stretch justify-center place-content-center bg-black text-white text-center backdrop-blur-sm';

  return (
    <div className={cn('relative min-h-8 w-fit', !isLoggedIn && 'min-w-32 overflow-hidden', props.className)}>
      {!isLoggedIn && (
        <>
          <Button
            to = {`/login?referrer=${location.pathname}${location.search}${location.hash}`}
            unstyled
            className={cn(
              overlayClassName,
              'text-base leading-[22px] text-text dark hidden pointer-events-none md:pointer-events-auto md:block opacity-0 hover:opacity-100 bg-transparent transition duration-150 hover:duration-hover hover:bg-black/40',
              props.alwaysShowOverlay && 'bg-black/40 opacity-100'
            )}
          >
            {props.overlayText}
          </Button>
          <Button
            onPress={((e) => {
              if(mobilePressedState) {
                history.push(`/login?referrer=${location.pathname}${location.search}${location.hash}`);
                return;
              }
              console.log('press');
              console.log(mobilePressedState);
              setMobilePressedState(true);
            })}
            onClickCapture={((e) => {
              e.preventDefault();
            })}
            onBlur={() =>{
              setMobilePressedState(false);
            }}
            to = {mobilePressedState && `/login?referrer=${location.pathname}${location.search}${location.hash}`}
            autoFocus={mobilePressedState && !props.alwaysShowOverlay}
            unstyled
            className={cn(
              overlayClassName,
              'pointer-events-auto md:pointer-events-none md:hidden opacity-0 bg-transparent transition duration-150',
              'items-center',
              mobilePressedState && 'duration-hover hover:bg-black/40 bg-black/40 opacity-100',
              props.alwaysShowOverlay && 'bg-black/40'
            )}
          >
            {props.overlayText}
          </Button>
        </>
      )}
      <div className={cn(
        'pointer-events-none md:pointer-events-auto',
        mobilePressedState && 'pointer-events-auto',
        isLoggedIn && 'pointer-events-auto',
        props.childrenWrapperClassName,
      )}>
        {props.children}
      </div>
    </div>
  );
};
